/* tslint:disable */

declare var Object: any;
export interface FileManagerInterface {
  "model_name": string;
  "model_item_id": number;
  "file_name": string;
  "file_description": string;
  "tag"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class FileManager implements FileManagerInterface {
  "model_name": string;
  "model_item_id": number;
  "file_name": string;
  "file_description": string;
  "tag": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: FileManagerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FileManager`.
   */
  public static getModelName() {
    return "FileManager";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FileManager for dynamic purposes.
  **/
  public static factory(data: FileManagerInterface): FileManager{
    return new FileManager(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FileManager',
      plural: 'FileManagers',
      path: 'FileManagers',
      idName: 'id',
      properties: {
        "model_name": {
          name: 'model_name',
          type: 'string'
        },
        "model_item_id": {
          name: 'model_item_id',
          type: 'number'
        },
        "file_name": {
          name: 'file_name',
          type: 'string'
        },
        "file_description": {
          name: 'file_description',
          type: 'string'
        },
        "tag": {
          name: 'tag',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
